//#region Imports
import AddressSchema from "_shared/addresses/address-schema";
import { parseOrThrow } from "_shared/_utilities/zod-schema-parser";
import CompanyProfile from "marketplace/companies/profiles/company-profile";
import MarketplaceIndividualInfoSchema from "marketplace/_schema/marketplace-individual-info-schema";
import { z } from "zod";
//#endregion

export type MarketplaceCompanyInfoJSON = z.infer<
  typeof MarketplaceCompanyInfoSchema.MarketplaceCompanyInfoZ
>;

export default class MarketplaceCompanyInfoSchema {
  public static readonly MarketplaceCompanyInfoZ = z.object({
    id: z.uuid().nullish(),
    type: z.string().nullish(),
    isVisible: z.boolean().nullish(),
    name: z.string().nullish(),
    yearEstablished: z.number().nullish(),
    numberOfEmployees: z.number().nullish(),
    contact: MarketplaceIndividualInfoSchema.MarketplaceIndividualInfoZ.nullish(),
    description: z.string().nullish(),
    location: AddressSchema.AddressJSONZ.nullish(),
    website: z.string().nullish(),
    avatar: z.string().nullish(),
    categories: z.string().array().nullish(),
  });

  public static validateJSON(json: unknown): MarketplaceCompanyInfoJSON {
    return parseOrThrow(MarketplaceCompanyInfoSchema.MarketplaceCompanyInfoZ, json, {
      logError: true,
      schemaName: "MarketplaceCompanyInfoSchema",
      operation: "validateJSON",
      payloadSample: json,
    });
  }

  public static isValidJSON(json: unknown): json is MarketplaceCompanyInfoJSON {
    return MarketplaceCompanyInfoSchema.MarketplaceCompanyInfoZ.safeParse(json).success;
  }

  public static deserializeToProfile(json: MarketplaceCompanyInfoJSON): CompanyProfile | null | undefined {
    if (!json.id) throw new Error("Company ID is required, was not returned by the API");
    if (!json.name) throw new Error("Name is required, was not returned by the API");
    return CompanyProfile.fromJSON(json);
  }
}
